import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

export const PasswordStrength = ({ password }) => {
  const getPasswordStrength = (password) => {
    if (!password) return { score: 0, label: '', color: 'error' };

    let score = 0;
    const checks = {
      length: password.length >= 8,
      lowercase: /[a-z]/.test(password),
      uppercase: /[A-Z]/.test(password),
      number: /\d/.test(password),
      special: /[-+_!@#$%^&*.,?]/.test(password)
    };

    score = Object.values(checks).filter(Boolean).length;

    if (score <= 2) return { score, label: 'Fraca', color: 'error' };
    if (score <= 3) return { score, label: 'Média', color: 'warning' };
    if (score <= 4) return { score, label: 'Boa', color: 'info' };
    return { score, label: 'Excelente', color: 'success' };
  };

  const { score, label, color } = getPasswordStrength(password);
  const percentage = (score / 5) * 100;

  if (!password) return null;

  return (
    <Box sx={{ mt: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LinearProgress
          variant="determinate"
          value={percentage}
          color={color}
          sx={{ flexGrow: 1, height: 6, borderRadius: 3 }}
        />
        <Typography variant="caption" color={`${color}.main`}>
          {label}
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Requisitos da senha:
        </Typography>
        <Box component="ul" sx={{ mt: 0.5, pl: 2, fontSize: '0.75rem' }}>
          <li style={{ color: password.length >= 8 ? 'green' : 'red' }}>
            Pelo menos 8 caracteres
          </li>
          <li style={{ color: /[a-z]/.test(password) ? 'green' : 'red' }}>
            Uma letra minúscula
          </li>
          <li style={{ color: /[A-Z]/.test(password) ? 'green' : 'red' }}>
            Uma letra maiúscula
          </li>
          <li style={{ color: /\d/.test(password) ? 'green' : 'red' }}>
            Um número
          </li>
          <li style={{ color: /[-+_!@#$%^&*.,?]/.test(password) ? 'green' : 'red' }}>
            Um caractere especial
          </li>
        </Box>
      </Box>
    </Box>
  );
};

export default PasswordStrength;
